export default class DefaultInput {
    constructor() {
        this.elements = document.querySelectorAll('[data-teaser-form] input[data-default]');
        this.teaserForm = document.querySelector('[data-teaser-form]');
        this.defaultValueAttr = 'data-default';
        this.init();
    }

    init() {
        if (this.elements.length === 0) {
            return false;
        }

        this.teaserForm.addEventListener('submit', () => {
            this.setDefaultValues(this.elements);
        });
    }

    setDefaultValues(fields) {
        fields.forEach((inputField) => {
            if (!inputField.value) {
                inputField.value = inputField.getAttribute(this.defaultValueAttr);
            }
        });
    }
}
